import { ApiConfiguration } from "src/app/data/szzAiApi/api-configuration";

export function customProvideApiConfiguration(rootUrl: string) {
  const config = new ApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ApiConfiguration,
    useValue: config,
  };
}
